import autoComplete from "@tarekraafat/autocomplete.js";

export function omsAutoComplete({
  selector,
  url_or_data,
  maxResults = 5,
  debounce = 500,
  threshold = null,
  onSelect = null,
  useQueryComponent = false,
}) {
  const inputEl = document.querySelector(selector);
  if(!inputEl.id) {
    console.debug('input id is missing from autocomplete element');
  }
  const commonProps = {
    selector: selector,
    resultsList: {
      id: inputEl.id + '-autocomplete-results',
      class: 'vf-autocomplete-results',
      noResults: true,
      maxResults: maxResults,
    },
    resultItem: {
      highlight: 'autocomplete-match'
    }
  }
  // if url, source the data from there
  if (typeof url_or_data === 'string') {
    new autoComplete(Object.assign(commonProps, {
      threshold: threshold || 3,
      debounce: debounce,
      data: {
        src: async(query) => {
          const url = useQueryComponent ? `${url_or_data}?query=${query}` : `${url_or_data}/${query}`;
          const source = await fetch(url);
          const data = await source.json();
          return data.suggestions;
        },
        keys: ['value'],
        cache: false
      },
    }));
  } else { // otherwise, its local
    new autoComplete(Object.assign(commonProps, {
      threshold: threshold || 1,
      data: {
        src: url_or_data,
        keys: ['value']
      },
    }));
  }
  if (onSelect && typeof onSelect === 'function') {
    document.querySelector(selector)
      .addEventListener('selection', event => onSelect(event.detail));
  }
}